export class PasswordResetRequired extends Error {
  constructor(readonly userId: string) {
    super('Please choose a password for this account.')
    Object.setPrototypeOf(this, PasswordResetRequired.prototype)
  }
}
